import { useMemo } from 'react';

import { useGetUserProfile } from '@/api/user-dashboard/queries';

const NO_GRANTS: readonly string[] = [];

export type AddressBookCategoryScope = {
  /** `null` is full view; an array is the granted category ids. */
  scope: readonly string[] | null;
  isScoped: boolean;
};

/**
 * An unresolved or failed profile reads as no grants, like `useCan`. A loaded profile
 * without the field reads as full view: only an API that predates category scopes omits
 * it, and that API enforces none, so locking the screen would contradict the server.
 */
export const useAddressBookCategoryScope = (): AddressBookCategoryScope => {
  const { user, isPending, isFetching, isInvalidated, isError } = useGetUserProfile();

  const isUnresolved = isPending || (isFetching && isInvalidated);
  const scope =
    isError || isUnresolved || !user ? NO_GRANTS : (user.addressBookCategoryScope ?? null);

  return useMemo(() => ({ scope, isScoped: scope !== null }), [scope]);
};
